import * as Sentry from '@sentry/react';
import { APP_VERSION, REPORT_ERRORS_TO_CONSOLE, SENTRY_ENVIRONMENT, SENTRY_KEY } from '../../../config';
import { REACT_SNAP_USER_AGENT } from '../../constants';

export function initMonitoring() {
  if (REPORT_ERRORS_TO_CONSOLE === 'false') {
    console.log = () => null;
    console.error = () => null;
    console.warn = () => null;
    console.info = () => null;
    console.debug = () => null;
  }
  if (navigator.userAgent !== REACT_SNAP_USER_AGENT) {
    Sentry.init({
      dsn: SENTRY_KEY,
      release: APP_VERSION,
      ignoreErrors: [
        //from https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/
        // Random plugins/extensions
        'top.GLOBALS',
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        'originalCreateNotification',
        'canvas.contentDocument',
        'MyApp_RemoveAllHighlights',
        'http://tt.epicplay.com',
        "Can't find variable: ZiteReader",
        'jigsaw is not defined',
        'ComboSearch is not defined',
        'http://loading.retry.widdit.com/',
        'atomicFindClose',
        // Facebook borked
        'fb_xd_fragment',
        // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
        // reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268
        'bmi_SafeAddOnload',
        'EBCallBackMessageReceived',
        // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        'conduitPage',
        '_avast_submit',
        //https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/17
        'Non-Error promise rejection captured',
        // The fetchInterceptor.ts monkey-patch can throw this error when it fails to fetch a resource, which is not actionable for Sentry.
        'Failed to fetch',
      ],
      denyUrls: [
        // Google Adsense
        /pagead\/js/i,
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      ],
      integrations: [Sentry.browserTracingIntegration()],
      environment: SENTRY_ENVIRONMENT,
      beforeSend: event => {
        if (event.exception) {
          if (
            event.exception.values &&
            event.exception.values[0] &&
            event.exception.values[0].stacktrace &&
            event.exception.values[0].stacktrace.frames
          ) {
            try {
              event.exception.values[0].stacktrace.frames.pop(); // Or shift
            } catch {}
          }
        }

        return event;
      },
    });

    const sentryReduxEnhancer = Sentry.createReduxEnhancer();
    return sentryReduxEnhancer;
  }
}
